export const MASTER_POLICY_OPTION = (
  policyName: string
) => `### **Wingspan Master Policy:**
- Enroll in Wingspan’s ${policyName} policy
  - Contractors with active enrollment automatically satisfy this requirement.
  - If you have not yet enrolled, you can do so on the next page.
`;

export const UPLOAD_USER_POLICY_OPTION = `### **Upload your COI:**
- Prepare your document
  - Have a digital copy of your COI ready for upload.
  - Make sure all information is legible and matches the verification requirements below.   
  - Check that your policy and coverage meet the requirements to avoid delays.

- Upload your document on the next page.
  - If you previously uploaded a valid document, consent to share it with the client.

- Consent to share
  - Once verified, consent to share your policy with the client.

- Accepted formats:
  - Document (pdf)
  - Image (jpeg, png, webp, heic, heif)
  - Max 100MBs per file
`;

export const INSURANCE = {
  masterPolicyOption: MASTER_POLICY_OPTION,
  uploadUserPolicyOption: UPLOAD_USER_POLICY_OPTION
};
